var link_preview_default = {
  "fontElementMap": "dR22c",
  "linkPreviewContainer": "d1zT7",
  "linkPreview": "wQs1I",
  "linkPreviewImage": "JKI9P",
  "linkPreviewPlaceholder": "mIUvi",
  "linkPreviewInfo": "gGrDC",
  "linkPreviewTitle": "D8au4",
  "linkPreviewDescription": "PNDAk",
  "linkPreviewUrl": "FUevO",
  "linkPreviewResponsiveImage": "_7bkz6",
  "loadingContainer": "SL-Cu",
  "errorIcon": "No1Qb",
  "errorInfo": "CydSD",
  "errorContainer": "P0S-c",
  "overlay": "dshNU",
  "thumbnailEnd": "xKPHf",
  "thumbnailStart": "q7zx2",
  "thumbnailTop": "wf5EF"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
